import { render, staticRenderFns } from "./EditCorrection.vue?vue&type=template&id=a1cfce6a&"
import script from "./EditCorrection.vue?vue&type=script&lang=js&"
export * from "./EditCorrection.vue?vue&type=script&lang=js&"
import style0 from "./EditCorrection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports